import { render, staticRenderFns } from "./ListRegistreringer.vue?vue&type=template&id=6e9412dd&scoped=true&"
import script from "./ListRegistreringer.vue?vue&type=script&lang=js&"
export * from "./ListRegistreringer.vue?vue&type=script&lang=js&"
import style0 from "./ListRegistreringer.vue?vue&type=style&index=0&id=6e9412dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9412dd",
  null
  
)

export default component.exports